<template>
  <div class="popup" @click="close_popup">
    <iframe class="mx-auto" :src="src"></iframe>
    <div class="option-bar">
      <span href="#" class="close-link">X</span>
    </div>
    <div class="option-bar2">
      <a href="#" class="back-link" @click.prevent="goBack">Back</a>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "IframePopup",
  data() {
    return {
      src: "static/game/"
    };
  },
  computed: {
    ...mapState(["current_section", "sections_content"]),
    ...mapGetters(["sectionContent", "eventTag", "getSection"])
  },
  methods: {
    close_popup(e) {
      if (e) e.preventDefault();
      this.$store.dispatch("set_popup_state", "");
    },
    goBack() {
      this.close_popup(null);

      setTimeout(
        function () {
          this.$store.dispatch("set_current_section", "5");
          this.$store.dispatch(
            "set_popup_state",
            this.sections_content["5"].type
          );
        }.bind(this),
        600
      );
    }
  },
  mounted() {
    this.$bus.$emit("on-request-ambience-fade", 0);
  },
  beforeDestroy() {
    if (
      this.$store.state.ambience_previous_vol >= 0 &&
      this.$store.state.ambience_previous_vol !=
        this.$store.state.ambience_current_vol
    ) {
      this.$bus.$emit(
        "on-request-ambience-fade",
        this.$store.state.ambience_previous_vol
      );
    }
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 0, 0, 0.9);
  top: 0;
  width: 100%;
  height: 100%;
}
.popup iframe {
  width: 90%;
  height: 88vh;
  margin-top: 6vh;
}

.option-bar {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
}
.option-bar2 {
  position: absolute;
  top: 10px;
  left: 10px;
  height: 35px;
  text-transform: uppercase;
}
.option-bar2 a {
  background: url("../../assets/icon-back-white.png") 0 center no-repeat;
  padding-left: 20px;
  color: #404040;
  display: inline-block;
  height: 35px;
  color: #fff;
  line-height: 35px;
  font-size: 0.9rem;
}
.close-link {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  display: inline-block;
  background: url("../../assets/close.png") 0 0 no-repeat;
  background-size: cover;
  width: 40px;
  height: 40px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/IframePopup.vue